import { render, staticRenderFns } from "./ManageExpenses.vue?vue&type=template&id=15d979fe&scoped=true&"
import script from "./ManageExpenses.vue?vue&type=script&lang=js&"
export * from "./ManageExpenses.vue?vue&type=script&lang=js&"
import style0 from "./ManageExpenses.vue?vue&type=style&index=0&id=15d979fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d979fe",
  null
  
)

export default component.exports